import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter } from "react-router-dom";
import { App } from "./App";
import { ClientConfigProvider } from "./lib/clientConfig";
import { applyTweaksToDom, getTweaks } from "./lib/tweaks";
import "./styles/globals.css";

// 初回ロード時にlocalStorageのTweaksをDOMに反映
applyTweaksToDom(getTweaks());

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = document.getElementById("root");
if (!root) throw new Error("#root not found");

ReactDOM.createRoot(root).render(
  <React.StrictMode>
    <ClientConfigProvider>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </QueryClientProvider>
    </ClientConfigProvider>
  </React.StrictMode>,
);
